import { useCallback, useEffect, useRef, useState } from "react";

/**
 * useScrollFade — retorna um ref para o container scrollável e
 * um booleano indicando se há conteúdo abaixo do scroll.
 *
 * Uso:
 *   const { scrollRef, canScrollMore } = useScrollFade();
 *   <div ref={scrollRef} onScroll={check} ...>
 *     ...conteúdo...
 *     {canScrollMore && <div className={styles.scrollFade} aria-hidden="true" />}
 *   </div>
 */
export function useScrollFade(deps = []) {
  const scrollRef = useRef(null);
  const [canScrollMore, setCanScrollMore] = useState(false);

  const check = useCallback(() => {
    const el = scrollRef.current;
    if (!el) return;
    setCanScrollMore(el.scrollHeight - el.scrollTop - el.clientHeight > 10);
  }, []);

  useEffect(() => {
    check();
    // re-check when content changes (deps)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [check, ...deps]);

  return { scrollRef, canScrollMore, check };
}
